import { esusApi } from "@/services/api";

export type ResumeIndicatorC5Params = {
	uf: string;
	ibgeCode: string;
	quarter: string;
	year: number;
	month: number;
	ine?: string;
};

export class ResumeIndicatorC5Data {
	totalHypertensiveCitizens: number = 0;
	totalHypertensiveCitizensInPeriod: number = 0;
	totalHypertensiveCitizensInPeriodScore: number = 0;
	maxHypertensiveCitizensInPeriodScore: number = 0;
}

export async function getResumeIndicatorC5({ uf, ibgeCode, ...params }: ResumeIndicatorC5Params) {
	const response = await esusApi.get<ResumeIndicatorC5Data>(
		`/uf/${uf}/city/${ibgeCode}/indicator/esf/c5/resume`,
		params
	);
	return response.data ?? new ResumeIndicatorC5Data();
}
